import styled from "styled-components";

const AboutMainWrap = styled.div`
  padding: 0px 0;
`

export default AboutMainWrap